export default __webpack_public_path__ + "static/berufsreise.alpinwelt-62104618310db2d121cc68c8184bf80e.jpg";